





































import { Vue, Component, Prop } from 'vue-property-decorator';
import StarIcon from '../icons/StarIcon.vue';
import Rating from '../common/inputs/Rating.vue';
import { SearchResultProcess } from '@/store/modules/searchInterfaces';
import { StatusLabels } from '../../models/status';
import { PhaseLabels } from '../../models/phase';
import { DomainLabels } from '../../models/domain';

@Component({
  components: {
    StarIcon,
    Rating
  }
})
export default class SearchResult extends Vue {
  @Prop(Object) process!: SearchResultProcess;
  @Prop(Boolean) bookmarked!: boolean;
  @Prop(Boolean) noPhase!: boolean;

  StatusLabels = StatusLabels;
  PhaseLabels = PhaseLabels;

  get domains() {
    return this.process.domains.map(domain => DomainLabels[domain]).join(', ');
  }
}
